var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"pickerAreaRef",staticClass:"picking-area",style:(_vm.pickerStyle),on:{"mousedown":_vm.mouseEvents}},[_c('div',{staticClass:"picking-area-overlay1"},[_c('div',{staticClass:"picking-area-overlay2"},[_c('div',{staticClass:"picker-pointer",style:(_vm.pointerStyle)})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }